import { html, TemplateResult } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { OutlineImage } from '@phase2/outline-image';
import componentStyles from './outline-block-image.css.lit';

/**
 * The image component.
 */
@customElement('outline-block-image')
export class OutlineBlockImage extends OutlineImage {
  static styles = [componentStyles];

  /**
   * Full width image
   */
  @property({ type: String, attribute: 'full-width' })
  fullWidth: string | boolean = false;

  /**
   * Image url
   */
  @property({ type: String, attribute: 'image-href' })
  imageHref: string | boolean = false;

  /**
   * Image text
   */
  @property({ type: String, attribute: 'image-label' })
  imageLabel: string | boolean = false;

  /**
   * Has title
   */
  @property({ type: String, attribute: 'has-title' })
  hasTitle: string | boolean = false;

  render(): TemplateResult {
    return html`${this.imageHref
      ? html`
        <figure class="${
          this.fullWidth === 'true' ? 'full-width' : 'fixed-width'
        }
        ${this.hasTitle === 'true' ? 'has-title' : ''}
        "></figure>
          <picture>
            <img src=${this.imageHref} alt="${ifDefined(this.imageLabel)}" />
          </picture>
          ${this.captionSlotTemplate()}
        </figure>`
      : html`<figure
          class="
          ${this.fullWidth === 'true' ? 'full-width' : 'fixed-width'}
          ${this.hasTitle === 'true' ? 'has-title' : ''}
          "
        >
          ${this.slots.renderInShadow('')}${this.captionSlotTemplate()}
        </figure>`} `;
  }
}
